/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable  no-nested-ternary */
import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _get from "lodash/get";
import _values from "lodash/values";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";
import { ExclamationIcon } from "@heroicons/react/outline";
import { useHistory, useParams } from "react-router-dom";
import { format } from "date-fns";
import { Formik, Field } from "formik";

import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import {
  getCompanySecretaryDocumentData,
  getDocumentData,
} from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm/documentData";
import FormFieldsCard from "components/lib/Global/FormFieldsCard";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import Tabs from "components/lib/Shared/Tabs";
import CommentsList from "components/lib/Global/CommentsList";
import { addComment, editComment } from "state/slices/comment";
import { useToast } from "hooks/useToast";
import {
  calculateCumulativeOwnership,
  getBeneficialOwnershipFormFields,
  getFormFields,
} from "utils";
import { editBeneficialOwnerAsync } from "state/slices/tables/beneficialOwnersTableSlice";
import BeneficialOwnersTable from "./BeneficialOwnersTable";
import { MinusIcon } from "@heroicons/react/outline";

function BeneficialOwnersSubRowAsync({
  visibleColumns,
  row,
  currentTab = null,
  handleEdit,
  handleDelete,
  handleBackBtn,
  selectedTableType,
  isInUpdateCompanyDetailsContext,
}) {
  const { beneficialOwners } = useSelector(
    (state) => state.beneficialOwnersTableSlice
  );

  const history = useHistory();
  const { companyId } = useParams();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const dispatch = useDispatch();

  // NEW: Detect if this is edit mode for a child needing review
  const isEditMode =
    isInUpdateCompanyDetailsContext &&
    (row.original?._needsReview || row.original?._isChildOfChangedParent);
  const [isSaving, setIsSaving] = useState(false);

  const isViewMode = history.location.pathname.split("/").pop() === "view";
  const { comments } = useSelector((state) => state.commentsSlice);
  const { toast } = useToast(5000);
  const { company } = useSelector((state) => state.companySlice);

  const stakeholderComments = comments.filter(
    (comment) =>
      comment?.officialId &&
      comment.officialId === row.original._id &&
      comment?.tabName &&
      comment.tabName === currentTab
  );

  const generalInformationComments = stakeholderComments.filter(
    (comment) =>
      comment.formName === "identificationDetails" ||
      comment.formName === "names"
  );
  const residentialDetailsComments = stakeholderComments.filter(
    (comment) =>
      comment.formName === "postalAddress" ||
      comment.formName === "electronicAddress" ||
      comment.formName === "residentialAddressDetails" ||
      comment.formName === "isNonResident"
  );

  const officialBeneficialOwnershipComments = stakeholderComments.filter(
    (comment) => comment.formName === "beneficialOwnershipForm"
  );
  const fileUploadComments = stakeholderComments.filter(
    (comment) => comment.formName === "uploadDocuments"
  );

  const {
    maxPercentShareholding,
    maxPercentVotingRights,
    directPercentShareholding,
    indirectPercentShareholding,
    directPercentVotingRights,
    indirectPercentVotingRights,
    directRightRemoveDirector,
    indirectRightRemoveDirector,
    directCompanyControlRight,
    indirectCompanyControlRight,
  } = row?.original?.beneficialOwnershipForm || {};

  const isDirectBeneficiary =
    directPercentShareholding >= 10 ||
    directPercentVotingRights >= 10 ||
    directRightRemoveDirector === "yes" ||
    directCompanyControlRight === "yes";
  const isIndirectBeneficiary =
    indirectPercentShareholding >= 10 ||
    indirectPercentVotingRights >= 10 ||
    indirectRightRemoveDirector === "yes" ||
    indirectCompanyControlRight === "yes";

  let validBOFormFieldsCount = 2;
  if (maxPercentShareholding > 0) validBOFormFieldsCount += 1;
  if (maxPercentVotingRights > 0) validBOFormFieldsCount += 1;
  const renderForm =
    _values(row?.original?.beneficialOwnershipForm).filter(
      (value) => value !== ""
    ).length > validBOFormFieldsCount;
  const renderLongForm =
    renderForm && (isDirectBeneficiary || isIndirectBeneficiary);
  const renderShortForm =
    renderForm && !isDirectBeneficiary && !isIndirectBeneficiary;

  const tabs = useMemo(() => {
    let tempTabs = [];
    if (renderShortForm) {
      tempTabs = [
        {
          id: "generalInformation",
          label: "General information",
          commentsCount: generalInformationComments?.length,
        },
        {
          id: "residentialDetails",
          label: "Address details",
          commentsCount: residentialDetailsComments?.length,
        },
        {
          id: "uploadDocuments",
          label: "File Uploads",
          commentsCount: fileUploadComments?.length,
        },
      ];
    }
    if (renderLongForm) {
      tempTabs = [
        {
          id: "officialBeneficialOwnership",
          label: "Beneficial ownership",
          commentsCount: officialBeneficialOwnershipComments?.length,
        },
        {
          id: "generalInformation",
          label: "General information",
          commentsCount: generalInformationComments?.length,
        },
        {
          id: "residentialDetails",
          label: "Address details",
          commentsCount: residentialDetailsComments?.length,
        },
        {
          id: "uploadDocuments",
          label: "File Uploads",
          commentsCount: fileUploadComments?.length,
        },
      ];
    }
    return tempTabs;
  }, [comments, renderLongForm, renderShortForm]);

  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const goToPrevStep = () => {
    if (selectedTabIndex === 0 && handleBackBtn) handleBackBtn();
    else setSelectedTabIndex(selectedTabIndex - 1);
  };

  const goToNextStep = () => {
    setSelectedTabIndex(selectedTabIndex + 1);
  };

  const handleSaveComment = async (data) => {
    if (!company?._id) {
      toast(
        "error",
        "Something went wrong please reload the page and try again."
      );
      return;
    }
    if (data?.commentId) {
      await dispatch(editComment({ commentId: data.commentId, data }));
    } else {
      await dispatch(
        addComment({
          data: {
            ...data,
            company: company._id,
            officialId: row.original._id,
            tabName: currentTab,
          },
        })
      );
    }
  };

  useEffect(() => {
    const tempSelectedTab = tabs[selectedTabIndex];
    if (tempSelectedTab) setSelectedTab(tempSelectedTab);
  }, [tabs, selectedTabIndex]);

  const isFirstStep = selectedTabIndex === 0;
  const isLastStep = tabs.length - 1 === selectedTabIndex;

  let dateOfBirth = _get(row.original.identificationDetails, "dateOfBirth");
  if (dateOfBirth) dateOfBirth = format(new Date(dateOfBirth), "yyyy/MM/dd");
  else dateOfBirth = "N/A";

  const [acceptingData, setAcceptingData] = useState(false);

  const officialIndex = beneficialOwners.findIndex(
    (official) => official._id === row.original._id
  );
  const officialSliceName = `beneficialOwnersTableSlice.beneficialOwners.${officialIndex}`;
  const companyOfficialEffectKey = "updateBeneficialOfficialState";

  const acceptData = async () => {
    if (!company?._id) {
      toast(
        "error",
        "Something went wrong please reload the page and try again."
      );
      return;
    }
    try {
      setAcceptingData(true);
      await dispatch(
        editBeneficialOwnerAsync({
          companyId: company?._id,
          beneficialOwnerId: row.original._id,
          data: {
            inviteStatus: "Approved",
            companyId: company?._id,
            idType: row?.original?.idType,
          },
        })
      );
      row.toggleRowExpanded();
    } catch (error) {
      console.error(error);
    } finally {
      setAcceptingData(false);
    }
  };

  // NEW: Save changes function for edit mode
  const saveChanges = async () => {
    if (!companyId) {
      toast("error", "Something went wrong. Please reload and try again.");
      return;
    }

    try {
      setIsSaving(true);

      await dispatch(
        editBeneficialOwnerAsync({
          companyId,
          beneficialOwnerId: row.original._id,
          data: {
            beneficialOwnershipForm: row.original.beneficialOwnershipForm,
            _needsReview: false,
            _isChildOfChangedParent: false,
            _parentHasChanges: false,
          },
        })
      );

      toast("success", "Changes saved successfully");
      row.toggleRowExpanded();
    } catch (error) {
      toast("error", "Failed to save changes");
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  if (row?.original?.children?.length > 1) {
    const { cumulativeShareholdings, cumulativeVotings } =
      calculateCumulativeOwnership(row?.original, beneficialOwners);

    let reviewBtnProps = {};
    if (row?.getToggleRowExpandedProps) {
      reviewBtnProps = row?.getToggleRowExpandedProps();
    }

    return (
      <tr className="bg-white">
        <td colSpan={visibleColumns.length}>
          <BeneficialOwnersTable
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            data={row?.original?.children}
            showActionColumn
            handleBackBtn={handleBackBtn}
            hideColumnsRow={true}
            selectedTableType={selectedTableType}
            isInUpdateCompanyDetailsContext={isInUpdateCompanyDetailsContext}
          />
          <div className="flex items-center justify-end w-full h-12 px-8 space-x-16 text-white bg-primary">
            <span>{`${cumulativeShareholdings}%, ${cumulativeVotings}%`}</span>
            <button
              type="button"
              {...reviewBtnProps}
              className={`border-white border-2 items-center rounded-full`}
            >
              <MinusIcon className="w-5 h-5 p-1" aria-hidden="true" />
            </button>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <tr className="bg-[#EDF0F5]">
      <td colSpan={visibleColumns.length} className="px-9">
        {/* NEW: Show edit mode banner if child needs review */}
        {isEditMode && (
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4 mt-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <ExclamationIcon className="h-5 w-5 text-blue-600" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">
                  Update Required
                </h3>
                <div className="mt-2 text-sm text-blue-700">
                  <p>
                    This beneficial owner's information needs to be updated to
                    reflect changes in their parent shareholder's ownership.
                    Please review and update the ownership percentages in the
                    "Beneficial ownership" tab.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
        {selectedTab.id === "generalInformation" && (
          <>
            {generalInformationComments &&
              generalInformationComments.length > 0 && (
                <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                  <CommentsList
                    comments={generalInformationComments}
                    toggleCommentStatus
                    applicantReviewer
                  />
                  <p className="mt-6 text-sm text-primary">
                    Comments: {generalInformationComments.length} of{" "}
                    {generalInformationComments.length}
                  </p>
                </div>
              )}
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getFormFields({
                idType: row.original.idType,
                formType: "names",
                formValues: row.original.names,
              })}
              resolvedFields={_get(row.original.names, "resolvedFields")}
              addReviewComment={!isEditMode}
              formName="names"
              formHelperKey="names"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.names`}
              formId={_get(row.original.names, "_id")}
              comments={generalInformationComments.filter(
                (comment) => comment.formName === "names"
              )}
            />
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getFormFields({
                idType: row?.original?.idType,
                formType: "identificationDetails",
                formValues: row?.original?.identificationDetails,
              })}
              resolvedFields={_get(
                row.original.identificationDetails,
                "resolvedFields"
              )}
              addReviewComment={!isEditMode}
              formName="identificationDetails"
              formHelperKey="identificationDetails"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.identificationDetails`}
              formId={_get(row.original.identificationDetails, "_id")}
              comments={generalInformationComments.filter(
                (comment) => comment.formName === "identificationDetails"
              )}
              files={row?.original?.fileUploads ?? {}}
            />
            {[
              "Local Company",
              "Foreign Company",
              "Other e.g Parastatals",
            ].includes(row?.original?.idType) && (
              <FormFieldsCard
                formName="identificationDetails"
                formHelperKey="identificationDetails"
                formId={_get(row.original.identificationDetails, "_id")}
                updateEffectKey={companyOfficialEffectKey}
                updateEffectPath={`${officialSliceName}.identificationDetails`}
                resolvedFields={_get(
                  row.original.identificationDetails,
                  "resolvedFields"
                )}
                fields={getFormFields({
                  idType: row?.original?.idType,
                  formType: "contactPersonInfo",
                  formValues: row?.original?.identificationDetails,
                })}
              />
            )}
          </>
        )}
        {selectedTab.id === "residentialDetails" && (
          <>
            {residentialDetailsComments &&
              residentialDetailsComments.length > 0 && (
                <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                  <CommentsList
                    comments={residentialDetailsComments}
                    toggleCommentStatus
                    applicantReviewer
                  />
                  <p className="mt-6 text-sm text-primary">
                    Comments: {residentialDetailsComments.length} of{" "}
                    {residentialDetailsComments.length}
                  </p>
                </div>
              )}
            {row?.original?.idType === "Kenyan Citizen" && (
              <FormFieldsCard
                handleSaveComment={handleSaveComment}
                fields={[
                  {
                    key: "Non-Resident",
                    name: "isNonResident",
                    value: row.original?.isNonResident ?? "N/A",
                  },
                ]}
                resolvedFields={_get(row.original, "resolvedFields")}
                addReviewComment={!isEditMode}
                formName="isNonResident"
                formHelperKey="beneficialOwner"
                updateEffectKey={companyOfficialEffectKey}
                updateEffectPath={officialSliceName}
                formId={_get(row.original, "_id")}
                comments={residentialDetailsComments.filter(
                  (comment) => comment.formName === "isNonResident"
                )}
              />
            )}
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getFormFields({
                idType:
                  row?.original?.isNonResident &&
                  row?.original?.isNonResident === "Yes"
                    ? "Foreigner"
                    : row?.original?.idType,
                formType: "postalAddress",
                formValues: row?.original?.postalAddress,
              })}
              resolvedFields={_get(
                row.original.postalAddress,
                "resolvedFields"
              )}
              addReviewComment={!isEditMode}
              formName="postalAddress"
              formHelperKey="postalAddress"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.postalAddress`}
              formId={_get(row.original.postalAddress, "_id")}
              comments={residentialDetailsComments.filter(
                (comment) => comment.formName === "postalAddress"
              )}
            />
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getFormFields({
                idType: row?.original?.idType,
                formType: "electronicAddress",
                formValues: row?.original?.electronicAddress,
              })}
              resolvedFields={_get(
                row.original.electronicAddress,
                "resolvedFields"
              )}
              addReviewComment={!isEditMode}
              formName="electronicAddress"
              formHelperKey="electronicAddress"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.electronicAddress`}
              formId={_get(row.original.electronicAddress, "_id")}
              comments={residentialDetailsComments.filter(
                (comment) => comment.formName === "electronicAddress"
              )}
            />
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getFormFields({
                idType:
                  row?.original?.isNonResident &&
                  row?.original?.isNonResident === "Yes"
                    ? "Foreigner"
                    : row?.original?.idType,
                formType: "residentialAddressDetails",
                formValues: row?.original?.residentialAddressDetails,
              })}
              resolvedFields={_get(
                row.original.residentialAddressDetails,
                "resolvedFields"
              )}
              addReviewComment={!isEditMode}
              formName="residentialAddressDetails"
              formHelperKey="residentialAddressDetails"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.residentialAddressDetails`}
              formId={_get(row.original.residentialAddressDetails, "_id")}
              comments={residentialDetailsComments.filter(
                (comment) => comment.formName === "residentialAddressDetails"
              )}
            />
          </>
        )}
        {selectedTab.id === "officialBeneficialOwnership" && (
          <>
            {officialBeneficialOwnershipComments &&
              officialBeneficialOwnershipComments.length > 0 && (
                <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                  <CommentsList
                    comments={officialBeneficialOwnershipComments}
                    toggleCommentStatus
                    applicantReviewer
                  />
                  <p className="mt-6 text-sm text-primary">
                    Comments: {officialBeneficialOwnershipComments.length} of{" "}
                    {officialBeneficialOwnershipComments.length}
                  </p>
                </div>
              )}
            <FormFieldsCard
              handleSaveComment={handleSaveComment}
              fields={getBeneficialOwnershipFormFields({
                beneficialOwnershipForm: row.original.beneficialOwnershipForm,
                reviewTab: !isEditMode, // Make editable if isEditMode
                beneficialOwner: row.original,
                beneficialOwners,
              })}
              resolvedFields={_get(
                row.original.beneficialOwnershipForm,
                "resolvedFields"
              )}
              addReviewComment={!isEditMode}
              formName="beneficialOwnershipForm"
              formHelperKey="beneficialOwnershipForm"
              updateEffectKey={companyOfficialEffectKey}
              updateEffectPath={`${officialSliceName}.beneficialOwnershipForm`}
              formId={_get(row.original.beneficialOwnershipForm, "_id")}
              comments={officialBeneficialOwnershipComments}
            />
          </>
        )}
        {selectedTab.id === "uploadDocuments" && (
          <>
            {fileUploadComments && fileUploadComments.length > 0 && (
              <div className="px-8 pt-5 pb-6 mt-6 bg-white">
                <CommentsList
                  comments={fileUploadComments}
                  toggleCommentStatus
                  applicantReviewer
                />
                <p className="mt-6 text-sm text-primary">
                  Comments: {fileUploadComments.length} of{" "}
                  {fileUploadComments.length}
                </p>
              </div>
            )}
            <div className="px-8 pt-5 pb-6 mt-6 bg-white">
              <h3 className="mb-2 text-lg">Uploaded incorporation forms</h3>
              <Formik
                enableReinitialize
                initialValues={{
                  fileUploads: row.original.fileUploads,
                }}
                onSubmit={() => null}
              >
                {() => {
                  return (
                    <div className="pl-4">
                      <Field
                        name="fileUploads"
                        component={FileUploadForm}
                        documentData={
                          row.original.designation === "Company Secretary"
                            ? getCompanySecretaryDocumentData(
                                row.original.idType
                              )
                            : getDocumentData(row.original.idType)
                        }
                        resolvedFields={_get(row.original, "resolvedFields")}
                        onlyPreview
                        addReviewComment={!isEditMode}
                        handleSaveComment={handleSaveComment}
                        formName="uploadDocuments"
                        formHelperKey="beneficialOwner"
                        updateEffectKey={companyOfficialEffectKey}
                        updateEffectPath={officialSliceName}
                        formId={_get(row.original, "_id")}
                        resolveAllFieldsCheckbox
                        fileUploadComments={fileUploadComments}
                      />
                    </div>
                  );
                }}
              </Formik>
            </div>
          </>
        )}
        <div className="flex justify-between">
          {!isFirstStep && (
            <button
              onClick={goToPrevStep}
              className="flex items-start float-right py-2 font-semibold rounded text-primary mt-7"
            >
              <span className="flex items-center mr-4 h-7">
                <ChevronLeftIcon
                  className="flex-shrink-0 w-5 h-5"
                  aria-hidden="true"
                />
              </span>
              <p className="font-semibold">Go back</p>
            </button>
          )}
          {isLastStep ? (
            <button
              disabled={isSaving || acceptingData}
              onClick={() => {
                if (isEditMode) {
                  // Save changes mode
                  saveChanges();
                } else if (stakeholderComments.length === 0) {
                  // Accept data mode
                  acceptData();
                } else {
                  // Just close
                  row.toggleRowExpanded();
                }
              }}
              className="flex items-center px-4 py-2 mb-2 font-semibold text-white rounded bg-green-focused mt-7 disabled:cursor-not-allowed"
            >
              {isSaving ? (
                <>
                  <SpinnerIcon />
                  Saving...
                </>
              ) : acceptingData ? (
                <>
                  <SpinnerIcon />
                  Accepting...
                </>
              ) : (
                <p>
                  {isEditMode
                    ? "Save Changes"
                    : isViewMode
                    ? "Close"
                    : stakeholderComments.length === 0
                    ? "Accept Data"
                    : "Confirm details"}
                </p>
              )}
              {!isViewMode && !isSaving && !acceptingData && (
                <span className="flex items-center ml-4 text-white h-7">
                  <ChevronRightIcon
                    className="flex-shrink-0 w-5 h-5"
                    aria-hidden="true"
                  />
                </span>
              )}
            </button>
          ) : (
            <button
              onClick={goToNextStep}
              className="flex items-start float-right py-2 ml-auto font-semibold rounded text-primary mt-7"
            >
              <p className="font-semibold">Review next step </p>
              <span className="flex items-center ml-4 h-7">
                <ChevronRightIcon
                  className="flex-shrink-0 w-5 h-5"
                  aria-hidden="true"
                />
              </span>
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

export default BeneficialOwnersSubRowAsync;
